// ADR-108 — pure helpers for the bench reports' Business Unit facet.
import { FACET_COUNT_MODES } from '../constants/benchReportFacets';

/**
 * ADR-108 §2.3: a selected business unit outside the Cluster scope is cleared;
 * an in-scope one with nobody on bench is kept (shown with 0).
 *
 * Only acts when the facet answered for the CURRENT selection — if the operator picked
 * another BU while the request was in flight, the stale answer is ignored.
 *
 * @param {Object|null} facet - `businessUnits` block of the facets response
 * @param {string} businessUnitId - current selection ('' when none)
 * @returns {boolean}
 */
export const shouldClearSelectedBusinessUnit = (facet, businessUnitId) => {
  if (!facet || !businessUnitId) {
    return false;
  }
  const selected = facet.selected;
  if (!selected || selected.id !== businessUnitId) {
    return false;
  }
  return !selected.inScope;
};

/**
 * Count shown next to a business-unit option.
 * @param {Object} unit - facet node ({ directCount, subtreeCount })
 * @param {string} countMode - FACET_COUNT_MODES value
 * @returns {number|null}
 */
export const getBusinessUnitFacetCount = (unit, countMode = FACET_COUNT_MODES.SUBTREE) => {
  if (!unit) {
    return null;
  }
  const value = countMode === FACET_COUNT_MODES.DIRECT ? unit.directCount : unit.subtreeCount;
  return typeof value === 'number' ? value : null;
};
